import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=45dad283&scoped=true"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=45dad283&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dad283",
  null
  
)

export default component.exports